<template>
    <Administrative>

        <Page :submenus="menus"/>

        <div class="-mt-4">
            <BreadcrumbsComponent :pages="pages" :is-dashboard="false"/>
            <div class="grid -mt-5">
                <div class="col-span-full">

                    <Table :fields="fields"
                           :items="topics"
                           :canView="true"
                           :empty_message="`Reviewed Subjects not found`"
                    >
                        <template #topic="{item}">
                            {{ item?.title }}
                        </template>
                        <template #total_reviews="{item}">
                            {{ item.review_students }} / {{ item.total_students }}
                        </template>
                        <template #rating="{item}">
                            {{ item?.rating_avg }} / 5
                        </template>

                        <template #action="{item}">
                            <inertia-link
                                :href="`${route(`administrative.faculty.view.review-topics`, [faculty.id, branch.id,item.id])}`">
                                <Button>
                                    Topics
                                </Button>
                            </inertia-link>
                        </template>


                    </Table>
                </div>

            </div>
        </div>
    </Administrative>
</template>
<script setup>
import Administrative from "@/Pages/Administrative/Administrative.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import {computed} from "vue";
import Page from '@/Components/Page'
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";


const topics = usePage().props.value.topics ?? [];
const faculty = usePage().props.value?.faculty ?? {};
const branch = usePage().props.value?.branch ?? {};
const course_years = usePage().props.value.course_years ?? [];
const course_year = usePage().props.value?.course_year ?? null;


const fields = [
    {'key': 'topic', 'label': 'Subject'},
    {'key': 'rating', 'label': 'rating'},
    {'key': 'action', 'label': 'Action'}
];

const menus = computed(() => {
    return course_years.map((item) => {
        return {
            'title': `${item.title}-${item.course.title}`,
            'active': (course_year.id === item.id),
            'route': `${route(`administrative.faculty.view.review`, [faculty.id, branch.id])}?course=${item.id}`,
            'visible': true
        };
    })
})
const pages = [
    {name: 'Faculties', href: route('administrative.faculty.list'), current: false},
    {
        name: ` ${faculty.first_name} ${faculty.last_name}`,
        href: route('administrative.faculty.view', faculty.id),
        current: false
    },
    {name: `${course_year.title}-${course_year.course.title} `, current: true},
]
//   {{course_year.title}}
// {{course_year.course.title}}
</script>
